import { render } from "./Lockers.vue?vue&type=template&id=a8ecc370"
import script from "./Lockers.vue?vue&type=script&lang=js"
export * from "./Lockers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__